// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"bc42c2957da1d56b97df","966":"1e3736159b4f71cc0617"}[chunkId] + ".js";
};